import { DEFAULT_LATEST } from 'constants/dateLimits';
import { REQUIRED } from 'constants/errors';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { accountNumberPattern } from 'constants/patterns';
import { FinancialNonPaymentItemModel } from '../types';

const nonpaymentInfractionOptions = [
  'Repossession',
  'Defaulted',
  'Collections',
  'Cancelled',
  'Evicted',
  'Garnished',
  'Delinquent',
  'Any',
];

export const financialNonPaymentItemValidator: ValidateJSModel<FinancialNonPaymentItemModel> = {
  Name: { hasValue: true },

  Infractions: {
    array: {
      validator: {
        inclusion: nonpaymentInfractionOptions,
      },
      length: { minimum: 1, message: REQUIRED },
    },
  },

  AccountNumber: (value, attributes) => {
    if (attributes?.AccountNumberNotApplicable?.applicable === false) { return {}; }
    return {
      hasValue: {
        validator: {
          format: {
            pattern: accountNumberPattern,
            message: 'error.delinquent.accountNumber.pattern',
          },
        },
      }
    };
  },

  AccountNumberExplanation: (value, attributes) => {
    if (attributes?.AccountNumberNotApplicable?.applicable === false) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  PropertyType: { hasValue: true },

  Amount: {
    model: {
      validator: currencyModelValidator,
    },
  },

  Reason: { hasValue: true },

  Status: { hasValue: true },

  Date: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { requireDay: false, earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
  }),

  Resolved: (value, attributes) => {
    if (attributes?.ResolvedNotApplicable?.applicable === false) { return {}; }

    return {
      presence: true,
      date: {
        requireDay: false,
        requireYear: false,
        latest: DEFAULT_LATEST,
        earliest: attributes?.Date,
        tooEarly: 'error.nonPayment.min',
      },
    };
  },

  Description: { hasValue: true },

  AmountEstimated: {},

  ResolvedNotApplicable: {},
  AccountNumberNotApplicable: {},
};
